module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0127.jpg?v=7b17614e";